<!-- Sidebar -->
<div class="sidebar-content" [class.height-sidebar]="!hasGlobalMessages()"
  [class.height-sidebar-global-message]="hasGlobalMessages()">

  <div class="sidebar__body">
    <!-- CATEGORIES -->
    <!-- Desktop only, and said twice on purpose. The @if is the intent; the class is what makes
         it true, because the server renders with no window and therefore as a desktop, and
         hydration leaves that markup in the DOM — the phone's sheet was showing the category
         heading and its list above FILTERS. -->
    @if (!isMobile() && !isInSearchMode()) {
    <section class="sidebar-content__nav d-flex flex-column gap-3 animated fadeInLeft">

      <!-- The category the shopper is in, as the rail's one title: the design gives the whole
           rail a single heading rather than a label per block. The collapse caret beside it is
           ShopComponent's own `.toggle-sidebar`, which already owns that corner. -->
      <header class="sidebar-content__heading">
        <h2>{{ signalsStore.selectedCategory().name || '' }}</h2>
      </header>

      <!-- The subcategories of whatever the heading above already names. One shared template
           for both shapes: on the shop there is a single root — the category being browsed —
           and repeating its name under its own heading is what the rail used to do. A filtered
           menu can hand back several roots, and those keep a label of their own. -->
      <ng-template #branchList let-items>
        <ul class="sidebar-content__branch">
          @for (branch of items; track branch.key) {
          <li>
            <span class="branch__name" [class.is-active]="branch.checked"
              (click)="goToShopSection(branch, $event)">
              {{branch.name}}
            </span>
            @if (branch.sublist?.length && showsLeaves(branch)) {
            <ul class="sidebar-content__leaves">
              @for (leaf of branch.sublist; track leaf.key) {
              <li [class.is-active]="leaf.checked">
                <span [class.is-active]="leaf.checked" (click)="goToShopSection(leaf, $event)">
                  {{leaf.name}}
                </span>
              </li>
              }
            </ul>
            }
          </li>
          }
        </ul>
      </ng-template>

      <nav class="sidebar-content__menu">
        @if (sidebarService.sidebarMenu().length === 1) {
        <ng-container [ngTemplateOutlet]="branchList"
          [ngTemplateOutletContext]="{ $implicit: sidebarService.sidebarMenu()[0].sublist ?? [] }"></ng-container>
        } @else {
        @for (item of sidebarService.sidebarMenu(); track item.id) {
        <details [open]="item.checked" name="subcategory">
          <summary [class.is-active]="item.checked" (click)="goToShopSection(item, $event)">
            {{item.name}}
          </summary>
          @if (item.sublist?.length) {
          <ng-container [ngTemplateOutlet]="branchList"
            [ngTemplateOutletContext]="{ $implicit: item.sublist ?? [] }"></ng-container>
          }
        </details>
        }
        }
      </nav>

    </section>
    }

    <!-- FILTERS -->
    <section class="filter-panel">

      <header class="filter-panel__head">
        <h3>FILTERS</h3>
        @if (isMobile()) {
        <button type="button" class="filter-panel__close" (click)="cancelFilters()" aria-label="Close the filters">
          <i class="fas fa-xmark" aria-hidden="true"></i>
        </button>
        } @else {
        <i class="fas fa-sliders filter-panel__glyph" aria-hidden="true"></i>
        }
      </header>

      <!-- Tags. Only on desktop: the mobile panel states the selection on the group headers and
           in the Apply count, and a tag strip on top of that pushed the first group off screen. -->
      @if (!isMobile() && sidebarService.filterTags().length) {
      <div class="tags">
        @for (item of sidebarService.filterTags(); track item.listId + '-' + item.sublistId) {
        <div class="tags__tag">
          <span>
            {{item.name}}
          </span>
          <i class="material-symbols-outlined" (click)="sidebarService.removeTag(item)">
            close
          </i>
        </div>
        }
      </div>
      }

      <!-- Groups -->
      <div class="filter-groups">
        @for (item of sidebarService.sidebar(); track item.key) {
        <div class="filter-group" [class.is-open]="isGroupOpen(item)">

          <button type="button" class="filter-group__head" (click)="toggleGroup(item)"
            [attr.aria-expanded]="isGroupOpen(item)">
            <span class="filter-group__name">{{ item.name }}</span>
            @if (item.countActiveFilters) {
            <span class="filter-group__badge">{{ item.countActiveFilters }}</span>
            }
            <i class="fas filter-group__caret" [class.fa-caret-up]="isGroupOpen(item)"
              [class.fa-caret-down]="!isGroupOpen(item)" aria-hidden="true"></i>
          </button>

          @if (isGroupOpen(item)) {
          <ul class="filter-group__body" [class.is-pills]="drawsPills(item)">
            @for (sublist of item.sublist; track sublist.id) {
            <li>
              @if (drawsPills(item)) {
              <!-- Pills are the design's shape for a group the backend marks as one. Nothing
                   marks any group yet, so this branch is dark in production today — see
                   SidebarCheckList.displayStyle. -->
              <button type="button" class="filter-pill" [class.is-on]="sublist.checked"
                [disabled]="!!sublist.disabled" (click)="toggleOption(item, sublist)"
                [attr.aria-pressed]="!!sublist.checked">
                @if (sublist.icon) {
                <img class="filter-pill__icon" [src]="sublist.icon" alt="" aria-hidden="true" />
                }
                <span class="filter-pill__label">{{ sublist.name }}</span>
              </button>
              } @else {
              <label class="filter-check">
                <input type="checkbox" [checked]="!!sublist.checked" [disabled]="!!sublist.disabled"
                  (change)="toggleOption(item, sublist)" />
                <i class="fa-regular fa-square filter-check__off" aria-hidden="true"></i>
                <i class="fa-solid fa-square-check filter-check__on" aria-hidden="true"></i>
                <span class="filter-check__label">{{ sublist.name }}</span>
              </label>
              }
            </li>
            }
          </ul>
          }
        </div>
        }
      </div>

    </section>
  </div>

  <!-- The phone's panel is a modal, so the selection is confirmed rather than applied on every
       tap: the service stages the ticks and only Apply reaches the catalogue. -->
  @if (isMobile()) {
  <footer class="filter-panel__foot">
    <button type="button" class="filter-panel__cancel" (click)="cancelFilters()">Cancel</button>
    <button type="button" class="filter-panel__apply" (click)="applyFilters()">
      {{ applyLabel() }}
    </button>
  </footer>
  }

  <h5 class="sidebar__title animated fadeInLeft">
    {{ signalsStore.selectedCategory().name || '' }}
  </h5>

</div>
